import Vue from "vue";
import Channel from "@/scripts/_channel.js";
import hub from "@/scripts/_hub.js";
import {
	EventBus
} from "../scripts/_eventBus.js";
import {
	mapActions
} from "vuex";

Number.prototype.pad = function (size) {
	var s = String(this);
	while (s.length < (size || 2)) {
		s = "0" + s;
	}
	return s;
}

export default {
	data() {
		return {
			// To adjust this value for development: copy the `.env` file then rename it to `.env.local` and adjust the values.
			baseUrl: process.env.VUE_APP_HOST_TOCC_TICKETING,
			isLoginValid: true
		};
	},
	methods: {
		...mapActions(["setProfile"]),
		T(text) {
			return hub.ui.versions.versioned(text, arguments);
		},
		V(model, path, versionCode) {

			var split = path.split(/[.|[|\]]+/);
			var defaultValue = model;
			
			for (var i = 0; i < split.length; i++) {
				if (defaultValue[split[i]] === undefined) {
					defaultValue = undefined;
				} else {
					defaultValue = defaultValue[split[i]];
				}
			}

			if (!model._Versioned && !defaultValue) throw new Error(`Passed model is not versioned and has no default name.`, model, path);
			if (!model._Versioned) return defaultValue;

			if(versionCode) {
				const versioned = model._Versioned.find(c => c.Path === path && c.Culture === hub.culture && c.VersionCode == versionCode);
				if (versioned) return versioned.Value;
			} 

			const versioned = model._Versioned.find(c => c.Path === path && c.Culture === hub.culture);
			if (versioned) return versioned.Value;

			// if there is no version, we return the default value
			return defaultValue
			
		},
		apiPostSynchronously(command, data) {
			//
			var request = new XMLHttpRequest();
			request.open("POST", this.baseUrl + command, false); // `false` makes the request synchronous
			if (Channel.bearerToken !== null) request.setRequestHeader("Authorization", "Bearer " + Channel.bearerToken)
			request.setRequestHeader("Content-Type", "application/json");
			request.send(JSON.stringify(data));

			return JSON.parse(request.responseText);
		},
		apiRequest(command, data, method, onSuccess, onError, opts) {
			//
			if (command.indexOf("alternatives") !== -1) command = command.replace(/availability\/alternatives/, "availability/alternatives/" + this.$route.params.channel.replace(/\//gmi, ""));
			else command = command.replace(/availability\/tickets/, "availability/tickets/" + this.$route.params.channel.replace(/\//gmi, ""));
			command = command.replace(/availability\/events/, "availability/events/" + this.$route.params.channel.replace(/\//gmi, ""));
			command = command.replace(/availability\/ticks/, "availability/ticks/" + this.$route.params.channel.replace(/\//gmi, ""));
			command = command.replace(/availability\/seasonal/, "availability/seasonal/" + this.$route.params.channel.replace(/\//gmi, ""));
			command = command.replace(/settings/, "settings/" + this.$route.params.channel.replace(/\//gmi, ""));
			this.request(this.baseUrl, command, data, method, opts, onSuccess, onError);
		},
		request(baseUrl, command, data, method, opts, onSuccess, onError) {
			var url = baseUrl + command;
			let request;

			//
			Vue.http.headers.common["Accept-Language"] = hub.culture;
			if (opts && opts.access_token) Vue.http.headers.common["Authorization"] = "Bearer " + opts.access_token;
			else if (Channel.bearerToken !== null) Vue.http.headers.common["Authorization"] = "Bearer " + Channel.bearerToken;
			if (method === "GET") request = Vue.http.get(url, opts);
			else if (method === "PUT") request = Vue.http.put(url, data, opts);
			else if (method === "POST") request = Vue.http.post(url, data, opts);
			else if (method === "DELETE") request = Vue.http.delete(url, opts);

			let _executeCallback = function (callback, response) {
				if (callback !== null) callback(response.body);
			};

			request.then(
				response => {
					_executeCallback(onSuccess, response);
				},
				response => {
					if (onError && response.status === 401) onError(response);
					else _executeCallback(onError, response);
				}
			);
		},
		checkForCookieLogin(onLoaded, onEmpty) {
			var profile_token = this.$cookies.get("profile_token");
			if (profile_token) this.loadProfile({
				Token: profile_token
			}, onLoaded, onEmpty);
			else if (onEmpty) onEmpty();
		},
		onSetProfile(profile) {
			if (profile) {
				this.$cookies.set("profile_token", profile.Token);
				this.setProfile(profile);
			} else {
				this.$cookies.remove("profile_token");
				this.setProfile({
					Credentials: {
						Login: "",
						Password: "",
						ex: {
							passwordRepeat: ""
						}
					},
					Contact: {},
					Payment: null,
					Token: ""
				});
			}
		},
		loadProfile(data, onLoaded, onEmpty, onComplete) {
			this.apiRequest(`/profile/${this.$route.params.channel}/login`, data, "POST", result => {
				if (result.Meta && result.Meta.IsValid && result.Value) {
					//
					this.isLoginValid = true;
					this.onSetProfile(result.Value);
					this.$emit("onProfileLoaded", result.Value);
					EventBus.$emit("loginSuccess", true);
					if (onLoaded) onLoaded();
				} else {
					this.isLoginValid = false;
					EventBus.$emit("loginSuccess", false);
					EventBus.$emit("loginPendingStatus", false);
					if (onEmpty) onEmpty();
				}
				if (onComplete) onComplete();
			}, (err) => {
				if (onComplete) onComplete(err);
			});
		}
	},
	computed: {
		hub() {
			return hub;
		}
	}
}